import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ClsConfig} from '../../../../util/cls-config';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent,
  IgxPrefixDirective, IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IgxButtonDirective, IgxButtonModule, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-filtro-general',
  templateUrl: './filtro-general.component.html',
  styleUrls: ['./filtro-general.component.scss'],
  imports: [
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxIconComponent,
    TranslateModule,
    IgxTextSelectionDirective,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxRippleDirective,
    IgxInputGroupComponent,
    IgxPrefixDirective,
    IgxSuffixDirective
  ]
})
export class FiltroGeneralComponent extends ClsConfig {
  @ViewChild('input', {read: IgxInputDirective, static: true})
  public input: IgxInputDirective;
  @Input()
  public descripcionLabel: string;
  @Input()
  public mostrarChkInicio = false;

  @Output()
  public enterPalabra: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  public limpiarPalabras: EventEmitter<HTMLInputElement> = new EventEmitter<HTMLInputElement>();

  public chkBuscarInicio: boolean;
  public textToolTip = 'MENSAJES.GRALS.CONTIENE';

  constructor() {
    super();
  }

  cambiarBusquedaInicio() {
    this.chkBuscarInicio = !this.chkBuscarInicio;
    if (this.chkBuscarInicio) {
      this.textToolTip = 'MENSAJES.GRALS.CONTIENEINICIO';
    } else {
      this.textToolTip = 'MENSAJES.GRALS.CONTIENE';
    }
  }

  onEnterBusPalabra(buscar: string) {
    this.enterPalabra.emit(buscar);
  }

  onClearInput(input: HTMLInputElement) {
    this.limpiarPalabras.emit(input);
  }
}
